export enum ExceptionStatus {
  OPEN = "OPEN",
  RESOLVED = "RESOLVED",
}
